import React from "react";
import styled from "styled-components";
import { sortBy } from "lodash";
import { Flex, Box } from "grid-styled";
import { reduxForm, Field, FieldArray, formValueSelector } from "redux-form";
import { TransmittalField } from "./forms";
import TransmittalStructureFields from "./TransmittalStructureFields";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "./Popover";
import Button from "./Button";

const formName = "transmittalEdit";
const selector = formValueSelector(formName);

const SpanButton = Button.withComponent("span");

const Actions = styled(Flex)`
  @media only print {
    display: none;
  }
`;

const required = value =>
  value || typeof value === "number" ? undefined : "Required";

class TransmittalEditorForm extends React.Component {
  addStructure = structureTemplate => {
    this.props.array.push("structures", {
      id: null,
      templateId: structureTemplate.id,
      transmittalData: {}
    });
  };

  renderCustomFields = (template, structure) => {
    const fieldPrefix = structure ? `${structure}.` : "";
    if (template) {
      const sortedFields = sortBy(template.custom_fields, "position");
      return sortedFields.map(cf => (
        <Box key={cf.key} pb={2}>
          <Field
            name={`${fieldPrefix}transmittalData.${cf.key}`}
            labelText={cf.name}
            component={TransmittalField}
            templateField={cf}
            disabled={!this.props.editable}
            validate={cf.required ? required : undefined}
          />
        </Box>
      ));
    }

    return null;
  };

  handleStructureClick = (template, e) => {
    this.addStructure(template);
  };

  renderStructureChoices = () => {
    const sortedStructures = sortBy(
      this.props.template.structure_templates,
      "position"
    );
    return sortedStructures.map(st => (
      <PopoverContentItem key={st.id} value={st}>
        {st.name}
      </PopoverContentItem>
    ));
  };

  renderStructures = ({ fields }) => {
    return fields.map((name, index) => (
      <TransmittalStructureFields
        template={this.props.template}
        key={index}
        selector={selector}
        name={name}
        removeStructure={
          this.props.editable ? () => fields.remove(index) : undefined
        }
        fieldRenderer={this.renderCustomFields}
      />
    ));
  };

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.props.onSubmit)}
        style={this.props.style}
      >
        {this.renderCustomFields(this.props.template)}
        <FieldArray name="structures" component={this.renderStructures} />
        {this.props.editable && (
          <Actions justify="flex-end">
            <Popover onSelection={this.handleStructureClick}>
              <PopoverTrigger type="button" style={{ marginRight: 4 }}>
                <SpanButton>Add Structure</SpanButton>
              </PopoverTrigger>
              <PopoverContent position="above">
                {this.renderStructureChoices()}
              </PopoverContent>
            </Popover>
            <Button type="submit" variant="primary">
              Save Transmittal
            </Button>
          </Actions>
        )}
      </form>
    );
  }
}

export default reduxForm({
  form: formName
})(TransmittalEditorForm);



// WEBPACK FOOTER //
// ./src/components/TransmittalEditorForm.js